<template>
  <app-content class="app-home-vue frame-page">
    <template v-if="currentAccountSets">
      <Row :space="18">
        <Cell width="6">
          <div class="h-panel home-top-card home-top-card--voucher">
            <div class="h-panel-bar home-top-card__bar">
              <div class="h-panel-title">{{ currentAccountSets.currentAccountDate|fqFormat }}</div>
              <div class="h-panel-right"><span class="gray-color">当期凭证</span><i class="h-split"></i><span class="font20 primary-color">{{ voucherCount }}</span><i class="h-split"></i><span class="gray-color">张</span></div>
            </div>
            <div class="text-hover h-panel-body home-top-card__body home-top-card__body--voucher" @click="addVouch">
              <div class="home-top-card__voucher-main">
                <div>
                  <div class="home-top-card__headline">新增凭证</div>
                  <div class="home-top-card__subline">录入摘要、会计科目和借贷分录，直接进入本期编辑页。</div>
                </div>
                <img src="../assets/voucherAdd.png" class="home-top-card__icon"/>
              </div>
              <div class="home-top-card__voucher-foot">
                <span>点击卡片进入录入</span>
                <i class="fa fa-long-arrow-right"></i>
              </div>
            </div>
          </div>
        </Cell>
        <Cell width="6">
          <div class="h-panel home-top-card">
            <div class="h-panel-bar home-top-card__bar">
              <div class="h-panel-title">货币资金</div>
              <div class="h-panel-right"><span class="gray-color">总资金</span><i class="h-split"></i><span v-tooltip :content="cashTotal" class="font20 primary-color text-hover">{{ cashTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div class="h-panel-body home-top-card__body home-top-card__body--list">
              <Row class="home-top-card__row" type="flex" v-for="cash in cashData" :key="cash.name">
                <Cell :flex="1" class="home-top-card__label">{{ cash.name }}</Cell>
                <Cell class="home-top-card__value"><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="6">
          <div class="h-panel home-top-card">
            <div class="h-panel-bar home-top-card__bar">
              <div class="h-panel-title">费用统计</div>
              <div class="h-panel-right"><span class="gray-color">总费用</span><i class="h-split"></i><span v-tooltip :content="costTotal" class="font20 primary-color text-hover">{{ costTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div class="h-panel-body home-top-card__body home-top-card__body--list">
              <Row class="home-top-card__row" type="flex" v-for="cash in costData" :key="cash.name">
                <Cell :flex="1" class="home-top-card__label">{{ cash.name }}</Cell>
                <Cell class="home-top-card__value"><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="6">
          <div class="h-panel home-top-card">
            <div class="h-panel-bar home-top-card__bar">
              <div class="h-panel-title">财务三表</div>
              <div class="h-panel-right"><span class="gray-color">快捷查看</span></div>
            </div>
            <div class="h-panel-body home-top-card__body">
              <div
                v-for="report in reportShortcuts"
                :key="report.id"
                class="home-report-shortcut text-hover"
                @click="openReport(report.id)"
              >
                <div>
                  <div class="home-report-shortcut__title">{{ report.name }}</div>
                  <div class="home-report-shortcut__desc">查看 {{ report.name }} 数据</div>
                </div>
                <span class="home-report-shortcut__arrow">进入</span>
              </div>
            </div>
          </div>
        </Cell>
        <Cell width="24">
          <div class="h-panel">
            <div class="h-panel-bar home-chart-bar">
              <div class="home-chart-bar__left">
                <div class="h-panel-title">营收与利润趋势</div>
                <Select
                  v-model="selectedRevenueYear"
                  :datas="revenueYearOptions"
                  keyName="key"
                  titleName="title"
                  :deletable="false"
                  class="home-chart-year-select"
                  @change="loadRevenueProfit"
                />
              </div>
              <div class="h-panel-right"></div>
            </div>
            <div class="h-panel-body home-part-body2">
              <Row :space="20">
                <Cell :width="24">
                  <Chart :options="revenueProfitOptions"></Chart>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
      </Row>
    </template>
    <div class="h-panel" v-else>
      <div class="h-panel-bar"><span class="h-panel-title">初始化账套</span></div>
      <div class="h-panel-body">
        <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
          <FormItem label="单位名称:" prop="companyName">
            <input type="text" v-model="form.companyName">
          </FormItem>
          <FormItem label="账套启用年月:" prop="enableDate">
            <DatePicker type="month" v-model="form.enableDate"/>
          </FormItem>
          <FormItem label="统一社会信用代码:">
            <input type="text" v-model="form.creditCode">
          </FormItem>
          <FormItem label="会计准则:" prop="accountingStandards">
            <Radio v-model="form.accountingStandards" dict="accountingStandards"></Radio>
          </FormItem>
          <FormItem label="单位所在地:">
            <CategoryPicker ref="CategoryPicker" :option="pickerOption" type="key" showAllLevels v-model="form.address"></CategoryPicker>
          </FormItem>
          <FormItem label="行业:">
            <Select v-model="form.industry" dict="industry"></Select>
          </FormItem>
          <FormItem label="增值税种类:" prop="vatType">
            <Radio v-model="form.vatType" dict="vatRadios"></Radio>
          </FormItem>
          <FormItem label="凭证是否需要审核:" prop="voucherReviewed">
            <Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>
          </FormItem>
          <FormItem single>
            <Button color="green" @click="submit" :loading="loading">创建账套</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </app-content>
</template>
<script>
import revenueProfit from '../js/data/revenueProfit';
import {getTotalData} from '../js/locations/district';
import {mapState} from 'vuex';
import moment from "moment";

const emptyForm = {
  "accountingStandards": "0",
  "address": null,
  "companyName": "",
  "creditCode": "",
  "enableDate": null,
  "fixedAssetModule": "0",
  "cashierModule": "0",
  "voucherReviewed": "0",
  "industry": "",
  "vatType": "0"
};


export default {
  name: 'Home',
  data() {
    return {
      revenueProfitOptions: revenueProfit,
      cashData: [{name: '库存现金', value: 0}, {name: '银行存款', value: 0}, {name: '其他货币资金', value: 0}],
      costData: [{name: '销售费用', value: 0}, {name: '管理费用', value: 0}, {name: '财务费用', value: 0}],
      reportShortcuts: [
        {id: 4, name: '利润表'},
        {id: 5, name: '现金流量表'},
        {id: 6, name: '资产负债表'}
      ],
      selectedRevenueYear: null,
      voucherCount: 0,
      loading: false,
      datas: [],
      type: 'type1',
      pickerOption: {
        keyName: 'id',
        titleName: 'title',
        dataMode: 'list',
        parentName: 'parentId',
        datas: getTotalData()
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ["companyName", "enableDate", "accountingStandards", "fixed_asset_module", "cashier_module", "voucherReviewed", "vatType"]
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
    revenueYearOptions() {
      if (!this.currentAccountSets) {
        return [];
      }
      let startYear = moment(this.currentAccountSets.enableDate).year();
      let endYear = moment(this.currentAccountSets.currentAccountDate).year();
      let years = [];
      for (let year = endYear; year >= startYear; year--) {
        years.push({key: year, title: `${year}年`});
      }
      return years;
    },
    costTotal() {
      let total = 0;
      this.costData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    },
    cashTotal() {
      let total = 0;
      this.cashData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    }
  },
  methods: {
    openMore() {
      this.$router.push({name: 'Chart'});
    },
    addVouch() {
      this.$router.push({name: 'VoucherForm'});
    },
    openReport(reportId) {
      this.$router.push({name: 'ReportView', params: {reportId}});
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
        this.$api.setting.accountSets[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.loading = false;
          window.location.reload();
        }).catch(() => {
          this.loading = false;
        })
      }
    },
    loadRevenueProfit() {
      if (!this.currentAccountSets || !this.selectedRevenueYear) {
        return;
      }
      Api.home.chart.revenueProfit({year: this.selectedRevenueYear}).then(({data}) => {
        this.updateRevenueProfitOptions(data);
      });
    },
    init() {
      if (this.currentAccountSets) {
        this.selectedRevenueYear = moment(this.currentAccountSets.currentAccountDate).year();
        Promise.all([
          Api.home.voucherCount(),
          Api.home.chart.cost(),
          Api.home.chart.cash(),
        ]).then((reslut) => {
          this.voucherCount = reslut[0].data;
          this.costData = reslut[1].data;
          this.cashData = reslut[2].data;
          this.loadRevenueProfit();
        });
      }
    },
    updateRevenueProfitOptions(chartData) {
      let lr = chartData["本年利润"] || {};
      let zysr = chartData["主营业务收入"] || {};
      let revenueData = new Array(12).fill(0);
      let profitData = new Array(12).fill(0);
      let marginData = new Array(12).fill(null);

      Object.keys(zysr).forEach(value => {
        let index = Number(value) - 1;
        revenueData[index] = Number((zysr[value] / 1000).toFixed(2));
      });
      Object.keys(lr).forEach(value => {
        let index = Number(value) - 1;
        profitData[index] = Number((lr[value] / 1000).toFixed(2));
      });
      let profitMonthSet = new Set(Object.keys(lr).map(value => Number(value) - 1));
      revenueData.forEach((revenue, index) => {
        if (!profitMonthSet.has(index) || revenue <= 0) {
          return;
        }
        let profit = profitData[index];
        marginData[index] = Number(((profit / revenue) * 100).toFixed(2));
      });

      let opt = JSON.parse(JSON.stringify(revenueProfit));
      opt.series[0].data = revenueData;
      opt.series[1].data = profitData;
      opt.series[2].data = marginData;
      this.revenueProfitOptions = opt;
    }
  },
  mounted() {
    this.$store.dispatch('init').then(() => {
      this.init();
    }).catch(() => {
      this.init();
    });
  }
};
</script>

<style scoped lang="less">
  .home-top-card {
    height: 184px;
    border-radius: 10px;
    overflow: hidden;
  }

  .home-chart-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
  }

  .home-chart-bar__left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .home-chart-year-select {
    min-width: 108px;
    display: inline-block;
  }

  .home-top-card__bar {
    min-height: 44px;
    padding-top: 10px;
    padding-bottom: 8px;
  }

  .home-top-card__body {
    padding: 4px 14px 12px;
  }

  .home-top-card--voucher .home-top-card__body {
    padding-top: 6px;
  }

  .home-top-card--reports .home-top-card__body {
    padding-top: 6px;
    padding-bottom: 10px;
  }

  .home-top-card__body--list {
    height: calc(100% - 44px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .home-top-card__body--voucher {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 44px);
  }

  .home-top-card__voucher-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .home-top-card__icon {
    width: 54px;
    height: 54px;
    flex: none;
    object-fit: contain;
    align-self: center;
  }

  .home-top-card__headline {
    font-size: 16px;
    font-weight: 600;
    color: #1f2329;
    line-height: 1.2;
  }

  .home-top-card__subline {
    margin-top: 6px;
    font-size: 11px;
    line-height: 1.5;
    color: #8c8c8c;
  }

  .home-top-card__voucher-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid #f1f3f5;
    color: #3366ff;
    font-size: 11px;
    font-weight: 600;
  }

  .home-top-card__row {
    min-height: 0;
    flex: 1;
    align-items: center;
    border-bottom: 1px solid #f1f3f5;
  }

  .home-top-card__row:last-child {
    border-bottom: 0;
  }

  .home-top-card__label {
    color: #5f6b7a;
    font-size: 12px;
  }

  .home-top-card__value {
    color: #1f2329;
    font-size: 12px;
  }

  .home-report-shortcut {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 0;
    padding: 7px 10px;
    border: 1px solid #edf1f5;
    border-radius: 8px;
    margin-bottom: 6px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    transition: all .2s ease;
  }

  .home-report-shortcut:last-child {
    margin-bottom: 0;
  }

  .home-report-shortcut:hover {
    border-color: #d7e2ff;
    background: #f7faff;
  }

  .home-report-shortcut__title {
    font-size: 13px;
    font-weight: 600;
    color: #1f2329;
    line-height: 1.2;
  }

  .home-report-shortcut__desc {
    display: none;
  }

  .home-report-shortcut__arrow {
    color: #3366ff;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
  }
</style>
